module.exports = __webpack_public_path__ + "static/media/Rectangle_3.65719526.png";